export default __webpack_public_path__ + "static/media/Book.6cb550cc.svg";